import { z } from 'zod';
/**
 * Append-only audit-log row (DEV-15916 / EU-91). Written by the API's
 * `AuditLogInterceptor` after every successful state-changing call;
 * surfaced via `GET /v1/audit-log`.
 */
export const AuditLogEntrySchema = z.object({
    id: z.string(),
    orgId: z.string(),
    /** Keycloak `sub` of whoever made the call. */
    principalSubject: z.string(),
    principalIsSuperuser: z.boolean(),
    /** HTTP method + normalized path, e.g. `POST /v1/workflows`. */
    action: z.string(),
    /** First segment after `/v1/`, e.g. `workflows`, `runs`. */
    resourceType: z.string(),
    /** Entity id from `req.params.id` or the response body when available. */
    resourceId: z.string().nullable(),
    statusCode: z.number().int(),
    metadata: z.record(z.string(), z.unknown()),
    ipAddress: z.string().nullable(),
    userAgent: z.string().nullable(),
    createdAt: z.date(),
});
/**
 * Optional filters for `GET /v1/audit-log`. All fields combine as AND.
 * Date strings are ISO datetimes; the controller pre-validates before
 * passing this to the service.
 */
export const ListAuditLogQuerySchema = z
    .object({
    /** Exact-match action string, e.g. `POST /v1/workflows`. */
    action: z.string().min(1).optional(),
    /** Exact-match resource type, e.g. `workflows`. */
    resourceType: z.string().min(1).optional(),
    /** Filter to a single actor's activity. */
    principalSubject: z.string().min(1).optional(),
    /** Filter to a single resource id (e.g. all writes against one workflow). */
    resourceId: z.string().min(1).optional(),
    since: z.string().datetime().optional(),
    until: z.string().datetime().optional(),
})
    .strict();
//# sourceMappingURL=audit.js.map